import React, { useCallback, useEffect, useState } from "react";
import Sidebar from "../Layouts/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../redux/api";

export default function PrivateRoutes({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [zatcaHoldActive, setZatcaHoldActive] = useState(false);

  const loadZatcaHoldStatus = useCallback(async () => {
    try {
      const response = await axiosInstance.get("zatca_hold/config");
      setZatcaHoldActive(Boolean(response?.data?.response?.is_holding_now));
    } catch (error) {
      setZatcaHoldActive(false);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token && location.pathname !== "/") {
      navigate("/");
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    setIsSidebarOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    loadZatcaHoldStatus();
    const intervalId = window.setInterval(loadZatcaHoldStatus, 60000);
    const handleConfigUpdated = (event) => {
      if (event?.detail && Object.prototype.hasOwnProperty.call(event.detail, "is_holding_now")) {
        setZatcaHoldActive(Boolean(event.detail.is_holding_now));
      } else {
        loadZatcaHoldStatus();
      }
    };
    window.addEventListener("zatcaHoldConfigUpdated", handleConfigUpdated);
    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("zatcaHoldConfigUpdated", handleConfigUpdated);
    };
  }, [loadZatcaHoldStatus]);

  return (
    <div className="header-sidebar app-shell">
      <div className="mobile-topbar">
        <button
          type="button"
          className="mobile-menu-btn"
          onClick={() => setIsSidebarOpen((prev) => !prev)}
          aria-label="Toggle menu"
        >
          <i className="fa fa-bars"></i>
        </button>
        <div className="mobile-topbar-title">Simple Fatoora Admin</div>
      </div>

      <div
        className={`sidebar-backdrop ${isSidebarOpen ? "show" : ""}`}
        onClick={() => setIsSidebarOpen(false)}
      ></div>

      <div className={`sidebar sidebar-panel ${isSidebarOpen ? "mobile-open" : ""}`}>
        <Sidebar />
      </div>
      <div className="right-side">
        {zatcaHoldActive && (
          <div className="zatca-hold-shell-banner">ZATCA downtime hold active</div>
        )}
        <div className="children mt-4">
          {children}
        </div>
      </div>
    </div>
  );
}
